<template lang="pug">
  b-form-select(
    :value="value"
    :size="size"
    :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
    @input="handleInput"
    )
    option(value=0 disabled selected) {{ $t("message.select_option") }}
    option(v-for="option in options" :value="option.league_id") {{ option.league_name }}
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    options: {
      type: Array,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e);
    }
  }
};
</script>
